import { useWorkspaceText } from '../interface-copy';
import { useNamespaceCopy } from '@/i18n/ns';
import { overlaysCopy } from '@/i18n/ns/overlays';
import { markdownPlainText } from '../plain-text';
import { useOptionalWorkspace } from '../context';

/**
 * Under a run chat whose run ended Failed: one quiet line that says so, and that nothing was saved.
 * It reads only the run record the server attached to the chat (`threadMeta.agentRun`): the status
 * is Failed and the record holds no Result. Tool text, the answer and the chat's own messages are
 * never read for it, and it never shows while the run is queued, running or waiting for approval.
 * The detail is the record's own `turn_failed` message, the one the Runs tab shows.
 */
export function RunOutcomeFooter() {
  const { text: uiText, rich: uiRich } = useWorkspaceText();
  const ws = useOptionalWorkspace();
  const copy = useNamespaceCopy(overlaysCopy);
  const run = ws?.threadMeta?.agentRun;
  if (!ws || !run) return null;
  const failed = run.status === 'failed' && !run.hasResult;
  // The server sends the agent and the record's own message only to the person who ran it; a
  // reader of a shared run chat gets the status alone and so the sentence only.
  const agentId = run.agentId;
  // The status region is mounted with the run chat and filled when the run turns out Failed, so
  // a run that fails while it is followed is announced.
  return (
    <div className="ws-run-outcome" role="status">
      {failed && <p>{copy.runFailedNoResult}</p>}
      {failed && agentId && run.errorCode === 'turn_failed' && run.error && (
        <small>{markdownPlainText(run.error)}</small>
      )}
      {failed && agentId && (
        <button
          type="button"
          className="ws-text-button"
          onClick={() => ws.openCanvas({ kind: 'agent', id: agentId, tab: 'runs' })}
        >
          {uiText('Open run details')}
        </button>
      )}
    </div>
  );
}
